<mat-form-field appearance="outline">
  <input matInput [placeholder]="placeholder()" [formControl]="control">
  <mat-icon matPrefix>search</mat-icon>
</mat-form-field>